import './button.css'
import filter from './img/filter.svg'
import dowload from './img/File download.svg'
import comment from './img/Comment.svg'
import pencil from './img/Pencil.svg'
import dowload2 from './img/Icons.svg'
import remove from './img/Remove.svg'
import check from './img/Check.svg'
import error from './img/Error.svg'
import plus from './img/Plus.svg'

export const ButtonLess = (props) => {
    return (
        <button style={{ background: props.type === 'remove' || props.type === 'x' ? '#C35E5E' : props.type === 'check' ? '#75A978' : props.disabled ? '#B3B3B3' : '', cursor: props.disabled ? 'not-allowed' : 'pointer', ...props.style }} className='button-component-less' type={props.typeButton} onClick={props.onClick} >
            <img style={props.icon || props.type ? { display: 'flex' } : { display: 'none' }}
                src={props.icon ? props.icon : props.type === 'filter' ?
                    filter : props.type === 'download' ?
                        dowload : props.type === 'downloadBlack' ?
                            dowload2 : props.type === 'comment' ?
                                comment : props.type === 'edit' ?
                                    pencil : props.type === 'remove' ?
                                        remove : props.type === 'check' ?
                                            check : props.type === 'x' ?
                                                error : props.type === 'plus' ?
                                                    plus : props.icon
                }
                alt='icon button' />
            {
                props.children
            }
        </button >
    )
}